import React, { forwardRef } from "react";
import LogoIcon from "../../assets/icons/Layer_1-2.svg";
import { FaAngleDown, FaAngleLeft } from "react-icons/fa";

const PrintableKpiTable = forwardRef(
  (
    {
      tableData,
      selectedTools,
      newKpiMapper,
      defaultNewKpiMapper,
      Infra,
      ProductTableShow,
      PendingComp,
      tab,
      Map,
      MapActive,
      List,
      ListActive,
    }: any,
    ref: any
  ) => {
    const mapper = selectedTools?.one ? newKpiMapper : defaultNewKpiMapper;

    return (
      <div ref={ref} className="w-full p-4 text-sm text-black bg-white">
        {/* Print Landscape Orientation Style */}
        <style>{`@page { size: landscape; }`}</style>

        {/* Tool Selection Header */}
        <div className="grid w-full grid-cols-6 mb-8">
          <div className="flex items-start justify-between col-span-4 pt-8">
            <div className="flex items-center gap-2">
              <h6 className="text-xl font-medium text-da-blue-600">
                Compare Tools
              </h6>
            </div>
          </div>
          <div
            style={{
              borderWidth: "0.4px 0.4px 0px 0.4px",
              borderStyle: "solid",
              borderColor: "#000000",
            }}
            className="h-24 col-span-1 p-2"
          >
            <h6 className="text-sm font-medium inter text-[#1E293B]">
              Compare
            </h6>
            <div
              style={{
                border: "1px solid #E2E8F0",
              }}
              className="flex items-center justify-between w-full h-10 px-2 mt-2 bg-white rounded-lg"
            >
              <span className="text-sm font-medium text-[#334155] line-clamp-1">
                {selectedTools?.one?.toolName || `Select Sanitation tool`}
              </span>
            </div>
          </div>
          <div
            style={{
              borderWidth: "0.4px 0.4px 0px 0px",
              borderStyle: "solid",
              borderColor: "#000000",
            }}
            className="h-24 col-span-1 p-2"
          >
            <h6 className="text-sm font-medium inter text-[#1E293B]">With</h6>
            <div
              style={{
                border: "1px solid #E2E8F0",
              }}
              className="flex items-center justify-between w-full h-10 px-2 mt-2 bg-white rounded-lg"
            >
              <span className="text-sm font-medium text-[#334155] line-clamp-1">
                {selectedTools?.two?.toolName || `Select Sanitation tool`}
              </span>
            </div>
          </div>
        </div>

        {/* Hidden Section for Table Data */}
        <div className="hidden">
          {tableData?.map((t: any, i: number) => (
            <div
              key={i}
              className="grid w-full grid-cols-6 border-t border-l border-black"
            >
              <div className="col-span-1 px-3 pt-8 border-b border-black">
                <p className="text-base font-bold text-[#334155]">
                  {t?.category}
                </p>
              </div>
              <div className="col-span-5 border-black border-x">
                {t?.subcategories?.map(
                  (sub: any, index: number, array: any[]) => (
                    <div key={index} className="grid w-full grid-cols-5">
                      <div className="flex items-center col-span-1 gap-3 px-3 border-b border-black min-h-14">
                        <img src={Infra} alt="" />
                        <small className="text-base font-medium text-[#334155]">
                          {sub.name}
                        </small>
                      </div>
                      <div className="col-span-4 border-l border-black">
                        {sub?.rows?.map((row: any, idx: number) => (
                          <div key={idx} className="grid w-full grid-cols-4">
                            <div className="flex items-center w-full col-span-2 px-2 border-b border-black min-h-14">
                              <span>{row?.label}</span>
                            </div>
                            <div className="flex items-center justify-center col-span-1 border-b border-l border-black">
                              <PendingComp />
                            </div>
                            <div className="flex items-center justify-center col-span-1 border-b border-l border-black">
                              <PendingComp />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          ))}
        </div>

        {/* KPI Level Mapping */}
        <div className="pb-10">
          {mapper?.level === "3 Step"
            ? mapper?.data?.docs?.map((t: any, i: number) => (
                <div
                  key={i}
                  className="grid w-full grid-cols-6 border-t border-l border-black"
                >
                  <div className="col-span-1 px-3 pt-8 border-b border-black">
                    <p className="text-base font-bold text-[#334155] capitalize">
                      {t?.category?.toLowerCase()}
                    </p>
                  </div>
                  <div className="col-span-5 border-black border-x">
                    {t?.data?.map((sub: any, index: number, array: any[]) => (
                      <div key={index} className="grid w-full grid-cols-5">
                        <div className="flex items-center col-span-1 gap-3 px-3 border-b border-black min-h-14">
                          <img src={Infra} alt="" />
                          <small className="text-base font-medium text-[#334155] capitalize">
                            {sub?.category?.toLowerCase()}
                          </small>
                        </div>
                        <div className="col-span-4 border-l border-black">
                          {sub?.data?.map((row: any, idx: number) => (
                            <div key={idx} className="grid w-full grid-cols-4">
                              <div className="flex items-center w-full col-span-2 px-2 border-b border-black min-h-14">
                                <span>{row?.title}</span>
                              </div>
                              <div className="flex items-center justify-center col-span-1 border-b border-l border-black">
                                <ProductTableShow
                                  prevData={selectedTools?.one?.kpiSelection}
                                  product={row}
                                  title={sub?.category}
                                />
                              </div>
                              <div className="flex items-center justify-center col-span-1 border-b border-l border-black">
                                <ProductTableShow
                                  prevData={selectedTools?.two?.kpiSelection}
                                  product={row}
                                  title={sub?.category}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            : mapper?.data?.docs?.map((sub: any, index: number) => (
                <div
                  key={index}
                  className="grid w-full grid-cols-6 border-t border-l border-black"
                >
                  <div className="flex items-center col-span-2 gap-3 px-3 border-b border-black min-h-14">
                    <img src={Infra} alt="" />
                    <small className="text-base font-medium text-[#334155]">
                      {sub?.name || sub?.category}
                    </small>
                  </div>
                  <div className="col-span-4 border-l border-black">
                    {sub?.data?.map((row: any, idx: number) => (
                      <div key={idx} className="grid w-full grid-cols-4">
                        <div className="flex items-center w-full col-span-2 px-2 border-b border-l border-black min-h-14">
                          <span>{row?.title}</span>
                        </div>
                        <div className="flex items-center justify-center col-span-1 border-b border-l border-black">
                          <ProductTableShow
                            prevData={selectedTools?.one?.kpiSelection}
                            product={row}
                            title={sub?.category}
                          />
                        </div>
                        <div className="flex items-center justify-center col-span-1 border-b border-l border-black">
                          <ProductTableShow
                            prevData={selectedTools?.two?.kpiSelection}
                            product={row}
                            title={sub?.category}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
        </div>
        {/* <div className="fixed hidden bottom-3 right-4 print:block no-break">
          <div className="flex items-center gap-4">
            <h5 className="text-xl font-medium text-da-blue-600">Powered By</h5>
            <img src={LogoIcon} alt="Logo" className="w-40 h-16" />
          </div>
        </div> */}
      </div>
    );
  }
);

export default PrintableKpiTable;
